import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgTryOn = function SvgTryOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-hidden": "true"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.25 1.5a.75.75 0 0 0-.75.75v3a.75.75 0 0 1-1.5 0v-3A2.25 2.25 0 0 1 2.25 0h3a.75.75 0 0 1 0 1.5h-3ZM18.75 0a.75.75 0 0 0 0 1.5h3a.75.75 0 0 1 .75.75v3a.75.75 0 0 0 1.5 0v-3A2.25 2.25 0 0 0 21.75 0h-3ZM6.937 5.944a4.125 4.125 0 1 0 4.057 4.875h2.012a4.125 4.125 0 1 0 0-1.5h-2.012a4.125 4.125 0 0 0-4.056-3.375Zm0 1.5a2.625 2.625 0 1 1 .001 5.25 2.625 2.625 0 0 1 0-5.25Zm10.125 5.25a2.625 2.625 0 1 1 0-5.25 2.625 2.625 0 0 1 0 5.25Zm-2.409 3.891c-1.699.887-3.607.887-5.306 0a.75.75 0 1 0-.694 1.33c2.133 1.113 4.56 1.113 6.694 0a.75.75 0 0 0-.694-1.33ZM23.25 18a.75.75 0 0 1 .75.75v3A2.25 2.25 0 0 1 21.75 24h-3a.75.75 0 0 1 0-1.5h3a.75.75 0 0 0 .75-.75v-3a.75.75 0 0 1 .75-.75Zm-21.75.75a.75.75 0 0 0-1.5 0v3A2.25 2.25 0 0 0 2.25 24h3a.75.75 0 0 0 0-1.5h-3a.75.75 0 0 1-.75-.75v-3Z",
    clipRule: "evenodd"
  })));
};

export { SvgTryOn as default };
//# sourceMappingURL=try-on.svg.js.map
